import "./App.css";
import Main from "./Component/Main";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faqs from "./Component/Faqs";
import CookiePolicy from "./Component/CookiePolicy";
import PaymentResult from "./Component/PaymentResult";
import {
  AcceptableUse,
  AccessibilityStatement,
  ConsumerRights,
  ElectronicCommunications,
  FraudPrevention,
  IntellectualProperty,
  LegalHub,
  LegalNotice,
  OrdersCancellations,
  PaymentsSecurity,
  PrivacyChoices,
  ProductCare,
  Promotions,
} from "./Component/PolicyPages";
import { useEffect } from "react";
import productData, { siteConfig } from "./Datas/productData";

const routeTitles = {
  "/": "New Collection",
  "/shop": "Shop",
  "/cartpage": "Shopping Bag",
  "/checkout": "Checkout",
  "/paysuccess": "Order Confirmation",
  "/about": "About",
  "/contact": "Contact",
  "/shipping": "Shipping",
  "/returns": "Returns",
  "/privacy": "Privacy",
  "/terms": "Terms",
  "/faqs": "FAQs",
  "/cookie-policy": "Cookie Policy",
  "/legal": "Legal and Policy Centre",
  "/payments-security": "Payments and Security",
  "/orders-cancellations": "Orders and Cancellations",
  "/product-care": "Product Care and Quality",
  "/promotions": "Pricing and Promotions",
  "/privacy-choices": "Privacy Choices",
  "/accessibility": "Accessibility Statement",
  "/acceptable-use": "Acceptable Use Policy",
  "/intellectual-property": "Intellectual Property Notice",
  "/consumer-rights": "Consumer Rights Notice",
  "/fraud-prevention": "Fraud Prevention Policy",
  "/electronic-communications": "Electronic Communications Policy",
  "/legal-notice": "Legal Notice and Contact",
  "/payment": "Payment Status",
};

function AppShell() {
  const location = useLocation();
  const isCheckout = location.pathname === "/checkout";
  const isHome = location.pathname === "/";
  const staticHeader = isHome || ["/cartpage", "/paysuccess"].includes(location.pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
    const productId = location.pathname.match(/^\/shopDetails\/(\d+)$/)?.[1];
    const product = productId
      ? productData.find((item) => String(item.id) === productId)
      : null;
    const basePath = location.pathname.startsWith("/shopDetails/")
      ? "/shop"
      : location.pathname;
    const section = product?.name || routeTitles[basePath] || "Online Store";
    document.title = `${section} | ${siteConfig.brandName}`;

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute(
        "content",
        product?.description || siteConfig.description
      );
    }
  }, [location.pathname]);

  return (
    <>
      {!isCheckout && <Header home={staticHeader} />}
      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/shipping" element={<Delivery />} />
        <Route path="/" element={<Main />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/legal" element={<LegalHub />} />
        <Route path="/payments-security" element={<PaymentsSecurity />} />
        <Route path="/orders-cancellations" element={<OrdersCancellations />} />
        <Route path="/product-care" element={<ProductCare />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/privacy-choices" element={<PrivacyChoices />} />
        <Route path="/accessibility" element={<AccessibilityStatement />} />
        <Route path="/acceptable-use" element={<AcceptableUse />} />
        <Route path="/intellectual-property" element={<IntellectualProperty />} />
        <Route path="/consumer-rights" element={<ConsumerRights />} />
        <Route path="/fraud-prevention" element={<FraudPrevention />} />
        <Route path="/electronic-communications" element={<ElectronicCommunications />} />
        <Route path="/legal-notice" element={<LegalNotice />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/payment" element={<PaymentResult />} />
        <Route path="/shopDetails/:id" element={<ProductDetail />} />
        <Route path="/cartpage" element={<CartPage />} />
        <Route path="/checkout" element={<CheckOut />} />
        <Route path="/paysuccess" element={<PaySuccess />} />
      </Routes>
      {!isCheckout && <Footer />}
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppShell />
      </Router>
    </CartProvider>
  );
}

export default App;
